import React from "react";
import "./ChairmanReport.scss";
import chairmanImg from "../../../assets/Gallery/chairman-new-img.jpg";
// import chairmanSign from "../../../assets/chairmanSign.png";
import chairmanSign from "../../../assets/Gallery/chairman-sign.png";

const ChairmanReport = () => {
  return (
    <>
      <div className="chairman_report">
        <div className="container">
          <div className="heading_box">Chairman's Message</div>
          <div className="chairman_report_text">
            <h5 className="text-center mb-5">Bismillahir Rahmanir Raheem</h5>

            <div className="row">
              <div className="col-lg-8 mt-auto">
                <p>Dear fellow shareholders</p>
                <p>Assalamu Alaikum,</p>
                <p>
                  It is with a deep sense of responsibility and pride that I
                  present the Annual Report of Rupali Insurance Company Limited
                  for the year ending December 31, 2024.
                </p>
                <p>
                  As Chairman, I have always believed that an insurance
                  company’s true strength lies not just in its financials but in
                  its integrity, resilience, and ability to serve its
                  policyholders during times of uncertainty. This year, Rupali
                  Insurance has upheld those values with consistency and care.
                  Our gross premium income reached Tk. 673.16 million, and net
                  profit soared to Tk. 127.7 million, reinforcing the financial
                  health and operational maturity of the institution.
                </p>
                <p>
                  The Company has remained fully compliant with all regulatory
                  requirements, operating transparently under the guidelines of
                  the Insurance Act 2010, IFRS, and directives from IDRA. We
                  took bold but prudent steps to strengthen risk management,
                  optimize our investment portfolio, and streamline our claims
                  process.
                </p>
              </div>
              <div className="col-lg-4 text-lg-end text-center order-first order-lg-last">
                <img
                  src={chairmanImg}
                  className="img-fluid my-3 w-75 rounded"
                  alt=""
                />
              </div>
            </div>

            <p>
              As one of the pioneers of this organization, I have witnessed
              Rupali Insurance grow fromstrength to strength over decades. We’ve
              weath- ered challenges together, always with a view to creating
              lasting value for our stakeholders. I believe that the foundation
              we have built—root- ed in ethical practices, prudent governance,
              and customer-centric values—will continue to guide Rupali
              Insurance toward greater excellence.
            </p>

            <p>
              I extend my sincere appreciation to our shareholders, valued
              policyholders, regulatory authorities, and our dedicated employees
              for their unwavering support. The future of Rupali Insurance is
              bright, and I trust that it will continue to rise as a symbol of
              reliability in the insurance landscape of Bangladesh.
            </p>

            <p>
              May this institution flourish in the years to come.
              <br />
              <br />
            </p>
            <div className="row">
              <div className="col-lg-6">
                <h5>Mostafa Golam Quddus</h5>
                <h6>Chairman</h6>
              </div>
              <div className="col-lg-6 text-end">
                <img src={chairmanSign} className="img-fluid" alt="" />
              </div>
            </div>

            <div className="chairman_sign"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChairmanReport;
